import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/document-templates')({
  staticData: { breadcrumb: 'Document Templates', breadcrumbKey: 'K_BREADCRUMB_DOCUMENT_TEMPLATES' },
  component: DocumentTemplatesLayout,
});

function DocumentTemplatesLayout() {
  return <Outlet />;
}
